import { permissions } from '../constants'

/**
 * @param {string[]} actualPermissions
 * @param {string[]} desiredPermissions
 * @returns {boolean}
 *
 * @example checkPermission(userDetails.permissions, [permissions.viewKbb])
 */
export const checkPermission = (actualPermissions, desiredPermissions) =>
  actualPermissions.some((permission) => desiredPermissions.includes(permission))

export const checkPreQualifyPermissions = (userDetails) => {
  if (process.env.NEXT_PUBLIC_PRE_QUALIFY_ENABLED !== 'True') {
    return false
  }

  return checkPermission(userDetails.permissions, [permissions.managePreQualify])
}

export const checkBarCodePermissions = () => {
  return process.env.NEXT_PUBLIC_BAR_CODE_SCANNER_ENABLED === 'True';
}
